'use client';

import classNames from 'classnames';
import { useEffect } from 'react';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import BookingFlowModuleList, {
  BookingFlowModule,
} from '@/components/utilities/content-modules/booking-flow-module-list/booking-flow-module-list';
import { Module } from '@/components/utilities/content-modules/module-list/module-list';
import Row from '@/components/utilities/row/row';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './my-trip.module.scss';

export interface MyTripProps {
  /** An array of the content modules to show */
  contentModules: Module[];
  /** Whether to remove the top padding for navigation*/
  hideMainNavigation?: boolean;
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const MyTrip = ({
  contentModules,
  hideMainNavigation = false,
  personalizationData,
  trackingData,
}: MyTripProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'my_trip' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className={classNames(styles.component, {
        [styles.hideMainNavigation]: hideMainNavigation,
      })}
    >
      <Container>
        <Row>
          <Column className={styles.wrapper}>
            <Row>
              <Column
                className={styles.innerWrapper}
                offset={{ laptop: 1 }}
                width={{ laptop: 10 }}
              >
                <BookingFlowModuleList
                  contentModules={
                    contentModules as unknown as BookingFlowModule[]
                  }
                />
              </Column>
            </Row>
          </Column>
        </Row>
      </Container>
    </div>
  );
};

MyTrip.displayName = 'MyTrip';

export default MyTrip;
